export default __webpack_public_path__ + "static/media/000_intro_part2.av1.3465c642.mp4";